import { render } from "./Parents.vue?vue&type=template&id=0e7ec07c"
import script from "./Parents.vue?vue&type=script&lang=js"
export * from "./Parents.vue?vue&type=script&lang=js"

import exportComponent from "/Users/arkane/Dev/Web/Projects/era.proj/era.dev.local/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__